import { useLocation } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { routes } from './app-routes';
import { routes as routesRevamp } from 'components/app/routes/app-routes-revamp';
import { useInitialState } from 'hooks/useInitialState';
import { checkMatchPath, stringToBool } from 'utils/misc';
import { useRevampJourney } from 'hooks/useRevampJourney';

import type { Route } from 'components/app/routes/app-routes-revamp';

const { NODE_ENV, VITE_ANY_PAGE_LANDING } = process.env;

export const useRoutes = () => {
  const location = useLocation();

  const flags = useFlags();
  const { hasStateInitialValue } = useInitialState();
  const { isRevampJourney } = useRevampJourney();

  const activeRoutes = (isRevampJourney ? routesRevamp : routes) as Route[];

  const { pathname } = location;

  const currentRoute = activeRoutes.find((route) =>
    checkMatchPath(pathname, route.path)
  );
  const anyPageLanding = stringToBool(VITE_ANY_PAGE_LANDING);
  const isLoginEnabled = NODE_ENV !== 'test';
  const isLandingPage = !!currentRoute?.isLanding;
  const isEndingPage = !!currentRoute?.isEnding;
  /* istanbul ignore next -- @preserve */
  const shouldShowPrompt = !isLandingPage && !isEndingPage;
  /* istanbul ignore next -- @preserve */
  const shouldRedirect =
    hasStateInitialValue && !isLandingPage && !anyPageLanding;

  const enabledRoutes = activeRoutes.filter((route) => {
    if (!route.featureFlag) {
      return true;
    }

    return flags[route.featureFlag];
  });

  return {
    isLoginEnabled,
    isLandingPage,
    routes: enabledRoutes,
    shouldShowPrompt,
    shouldRedirect,
    currentRoute
  };
};
